export const HOMEPAGE_REFERENCE = 'HOMEPAGE';
